import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";
import { ChannelResource } from "@/types/resources";
import { api } from "@/utils/api";

const Card = styled.div`
  box-shadow: 0px 0px 2px 0px #00000014;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  margin-bottom: 16px;
  padding: 16px;
  display: flex;
  align-items: flex-start;
`;

const Icon = styled.svg`
  color: ${({ theme }) => theme.colors.warning};
  margin-right: 8px;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const UnassignedChannelsCard: FC = () => {
  const { data: channels, isLoading } = useQuery(
    ["channels", { forMetaBusinessAssigment: true }],
    () =>
      api.get<never, Array<Pick<ChannelResource, "id" | "name">>>(
        `/v1/channels/unassigned`
      ),
    {
      refetchOnMount: true,
    }
  );

  const names = channels?.map((c) => c.name).join(" · ");

  if (isLoading || !channels?.length) {
    return null;
  }

  return (
    <Card>
      <Icon
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="18" height="18" rx="9" fill="currentColor" />
        <path
          d="M8 11.5882V13H10V11.5882H8ZM8 5V10.6471H10V5H8Z"
          fill="white"
        />
      </Icon>
      <Content>
        <Text $type="smallBold">
          {channels.length} Pages need to be assigned to business account
        </Text>
        <Text $type="smallNormal">{names}</Text>
      </Content>
    </Card>
  );
};

export default UnassignedChannelsCard;
